import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./auth/auth.css";
import { API_KEY, BASE_URL, AUTH_BASE_URL } from "./config";


const SignupPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  const handleSignup = async () => {
    setError(null);
    setMessage(null);
    try {
      const res = await fetch(`${AUTH_BASE_URL}/auth/signup`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password })
      });

      if (!res.ok) throw new Error();

      setMessage("Account created successfully");
      setTimeout(() => navigate("/login"), 1500);
    } catch {
      setError("Signup failed");
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-title">Create Account</div>
        <div className="auth-subtitle">
          Start your journey with SignalFly
        </div>

        {error && <div className="auth-error">{error}</div>}
        {message && <div className="auth-success">{message}</div>}

        <input
          className="auth-input"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <input
          className="auth-input"
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <button className="auth-btn" onClick={handleSignup}>
          Create Account
        </button>

        <div className="auth-links">
          Already have an account?{" "}
          <span onClick={() => navigate("/login")}>Login</span>
        </div>
        <div className="auth-links">
            Back to{" "}
            <span onClick={() => navigate("/")}>Home</span>
          </div>
      </div>
    </div>
  );
};

export default SignupPage;
